import { render } from "./upload_normal.vue?vue&type=template&id=62ce4ce3&scoped=true"
import script from "./upload_normal.vue?vue&type=script&lang=js"
export * from "./upload_normal.vue?vue&type=script&lang=js"

import "./upload_normal.vue?vue&type=style&index=0&id=62ce4ce3&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ce4ce3"]])

export default __exports__